"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    ReceiptLineLabel: ()=>ReceiptLineLabel
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const index_cjs_namespaceObject = require("../PlainButton/index.cjs");
const external_IconButton_index_cjs_namespaceObject = require("../IconButton/index.cjs");
const external_Text_index_cjs_namespaceObject = require("../Text/index.cjs");
const external_ReceiptLineLabel_variants_cjs_namespaceObject = require("./ReceiptLineLabel.variants.cjs");
const external_utils_index_cjs_namespaceObject = require("../../utils/index.cjs");
const external_Tooltip_index_cjs_namespaceObject = require("../Tooltip/index.cjs");
function ReceiptLineLabel({ children, className, type = 'string', textStyle = 'body2', palette = 'neutral', bold = false, imageBefore = false, iconButtonRight = false, onClickPlainButton, helperIconText = '', shade = '8', ...props }) {
    const { root, paragraph, span, tooltipTrigger } = (0, external_ReceiptLineLabel_variants_cjs_namespaceObject.receiptLineLabelVariant)(props);
    let iconButtonSize;
    switch(textStyle){
        case 'body3':
            iconButtonSize = '3xs';
            break;
        case 'body2':
            iconButtonSize = '2xs';
            break;
        default:
            iconButtonSize = 'xs';
    }
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: (0, external_utils_index_cjs_namespaceObject.cn)(root(), className),
        ...props,
        children: [
            imageBefore && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.Span, {
                textStyle: textStyle,
                className: span(),
                children: "[VIP]"
            }),
            'plainButton' === type ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.PlainButton, {
                onClick: onClickPlainButton,
                type: "primary",
                textStyle: textStyle,
                children: children
            }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.P, {
                shade: shade,
                textStyle: textStyle,
                palette: palette,
                bold: bold,
                className: (0, external_utils_index_cjs_namespaceObject.cn)(paragraph(), className),
                children: children
            }),
            iconButtonRight && helperIconText?.length > 0 && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Tooltip_index_cjs_namespaceObject.Tooltip, {
                className: tooltipTrigger(),
                align: "start",
                color: "neutral",
                emphasis: true,
                showArrow: true,
                side: "top",
                hoverable: true,
                delay: 0,
                triggerNode: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_IconButton_index_cjs_namespaceObject.IconButton, {
                    iconName: "info",
                    size: iconButtonSize,
                    type: "plainSecondary",
                    fillNone: true
                }),
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.Span, {
                    children: helperIconText
                })
            })
        ]
    });
}
exports.ReceiptLineLabel = __webpack_exports__.ReceiptLineLabel;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "ReceiptLineLabel"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
